import React, { ReactNode } from 'react';
import { ActionsFeature, TblSection } from './table.types';

export type TblSectionsParams = {
    actions?: ActionsFeature[];
    sections?: TblSection[];
    children?: ReactNode;
};

const TableSections = ({ actions, sections, children }: TblSectionsParams): JSX.Element => {
    return (
        <tr>
            {actions?.map(action => (
                <th
                    key={action.columnTitle}
                    colSpan={1}
                    className="tbl-action-header"
                >
                    {action.columnTitle}
                </th>
            ))}
            {sections
                ? sections.map((section, idx) => (
                      <th
                          key={idx}
                          colSpan={section.span}
                      >
                          {section.title}
                      </th>
                  ))
                : null}
            {children}
        </tr>
    );
};

export default TableSections;
